// extracted by mini-css-extract-plugin
export default {"squareContainer":"squareContainer_squareContainer__Jx6d8"};